<template>
    <div id="withdrawhistory">
        <Header />
            <div class="container">
                <div class="menu_left_box">
                    <Chargenav :selectedType="NavSelecteType" />
                </div>
                <div class="withdrawhistory_box">
                    <div class="title">
                        <h1>포인트 출금내역</h1>
                    </div>
                    <div class="searchArea">
                        <div class="searchOption">
                            <!-- <select v-model="selectedCurrencyIdx" @change="changeCurrency()">
                                <option value="-1">전체 종목</option>
                                <option v-for="(item, index) in $store.state.currencyList" :key="index" :value="item.idx">{{item.name}}</option>
                            </select>
                            -->
                            <datepicker :format="customFormatter" class="date date1" v-model="startDate" :language="ko" v-on:closed="changeStartDate()"></datepicker>
                            <span class="wave">~</span>
                            <datepicker :format="customFormatter" class="date date2" v-model="endDate" :language="ko" v-on:closed="changeEndDate()"></datepicker>
                        </div>
                        <div class="button" @click="getWithdrawHistory">
                            <p>조회</p>
                        </div>
                    </div>
                    <div class="table_box">
                        <table>
                            <tr>
                                <th class="date">날짜</th>
                                <th>신청 포인트(AP)</th>
                                <th>당시 시세(₩)</th>
                                <th>출금 수수료(AP)</th>
                                <th>실 지급 코인(ATT)</th>
                                <th>상태</th>
                            </tr>
                            <tr class="list1" v-for="(item, index) in withdrawHistoryList" :key="index" :class="[index % 2 === 1 ? 'dark' : '']">
                                <td>{{item.createDate.substring(0,16)}}</td>
                                <td>{{item.reqAmount | comma}}</td>
                                <td>{{item.tokenPrice | comma}}</td>
                                <td>{{item.feeAmount | comma}}</td>
                                <td>{{item.finalAmount | comma}}</td>
                                <td>
                                    <a class="state_complete" :href="siteConfig.etherscanUrl + 'tx/' + item.txHash" target="_blank" v-if="item.state === 18"> 완료 </a>
                                    <p class="state_cancel" v-else-if="item.state === 3 || item.state === 4">승인취소</p>
                                    <p class="state_ing" v-else>처리중</p>
                                </td>
                            </tr>
                            <!-- <tr class="dark list2">
                                <td>2021.07.28 18:51</td>
                                <td>740,000 AP</td>
                                <td>12.95</td>
                                <td>-100ATT</td>
                                <td>95.830 ATT</td>
                                <td class="state_complete">완료</td>
                            </tr>
                            <tr class="list3">
                                <td>2021.07.28 18:51</td>
                                <td>740,000 AP</td>
                                <td>12.95</td>
                                <td>-100ATT</td>
                                <td>95.830 ATT</td>
                                <td class="state_complete">완료</td>
                            </tr>
                            <tr class="dark list4">
                                <td>2021.07.28 18:51</td>
                                <td>740,000 AP</td>
                                <td>12.95</td>
                                <td>-100ATT</td>
                                <td>95.830 ATT</td>
                                <td class="state_complete">완료</td>
                            </tr>
                            <tr class="list5">
                                <td>2021.07.28 18:51</td>
                                <td>740,000 AP</td>
                                <td>12.95</td>
                                <td>-100ATT</td>
                                <td>95.830 ATT</td>
                                <td class="state_cancel">승인취소</td>
                            </tr> -->
                        </table>
                    </div>
                    <div class="no_history">
                        <img src="../assets/images/icon_no_history.svg" />
                        <p>출금 내역이 없습니다.</p>
                    </div>
                    <ul class="pagination" v-if="totalRecordSize > 0">
                        <li class="left" @click="prevPage()"><img src="../assets/images/icon_left_arrow.svg" /></li>
                        <li class="current" v-if="pageList.length <= 0">1</li>
                        <li v-for="(item, index) in pageList" :key="index" :class="{'on' : item === currentPageNo}" @click="movePage(item)">{{item}}</li>
                        <li class="right" @click="nextPage()"><img src="../assets/images/icon_right_arrow.svg" /></li>
                    </ul>
                </div>
            </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Chargenav from '../components/Chargenav.vue'
import Datepicker from 'vuejs-datepicker';
import {ko} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'Home',
        pageCategory: '',
        components: {
            Header,
            Footer,
            Chargenav,
            Datepicker,
    },
    data() {
        return {
            NavSelecteType: 'Withdrawhistory',

            ko: ko,
            startDate: '',
            endDate: '',
            lastStartDate: '',
            lastEndDate: '',

            withdrawHistoryList:[],

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 10,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[]
        }
    },
    async created(){
        await this.mixinSiteConfigCheck();
        this.setDefaultDate();
        this.getWithdrawHistory();
    },
    methods:{
        customFormatter(date){
            return this.$moment(date).format('YYYY-MM-DD');
        },
        leadingZeros(n, digits) {
            var zero = '';
            n = n.toString();
            if (n.length < digits) {
                for (var i = 0; i < digits - n.length; i++)
                    zero += '0';
            }
            return zero + n;
        },
        setDefaultDate(){
            var startDate = new Date();
            var endDate = new Date();
            startDate.setDate(startDate.getDate() - 6);
            var convertStartDate = this.leadingZeros(startDate.getFullYear(), 4) + '-' + this.leadingZeros(startDate.getMonth() + 1, 2) + '-' + this.leadingZeros(startDate.getDate(), 2);
            var convertEndDate = this.leadingZeros(endDate.getFullYear(), 4) + '-' + this.leadingZeros(endDate.getMonth() + 1, 2) + '-' + this.leadingZeros(endDate.getDate(), 2);
            
            this.startDate = convertStartDate;
            this.lastStartDate = convertStartDate;
            
            this.endDate = convertEndDate;
            this.lastEndDate = convertEndDate;
        },
        changeStartDate(){
            var selectedStartDate = this.customFormatter(new Date(this.startDate));
            this.startDate = selectedStartDate;

            if(this.lastStartDate === this.startDate){
                return;
            }
            else{
                this.lastStartDate = this.startDate;

                // this.currentPageNo = 1;
                // this.listCount = 0;
                // this.pageCount = 0;
                // this.pageNo = 0;
                // this.pageSize = 0;
                // this.totalRecordSize = 0;
                // this.pageList = [];

                // this.getWithdrawHistory();
            }
        },
        changeEndDate(){
            var selectedEndDate = this.customFormatter(new Date(this.endDate));
            this.endDate = selectedEndDate;
            
            if(this.lastEndDate === this.endDate){
                return;
            }
            else{
                this.lastEndDate = this.endDate;

                // this.currentPageNo = 1;
                // this.listCount = 0;
                // this.pageCount = 0;
                // this.pageNo = 0;
                // this.pageSize = 0;
                // this.totalRecordSize = 0;
                // this.pageList = [];
                
                // this.getWithdrawHistory();
            }
        },
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getWithdrawHistory();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getWithdrawHistory();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getWithdrawHistory();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getWithdrawHistory(){
            var param = 
            {
                apiStartDate: this.startDate,
                apiEndDate: this.endDate,
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
            }
            this.$Axios.post(`${this.host}/erc20/withdraw/history`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(async(res) => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.withdrawHistoryList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
                else{
                    this.$router.push('/');
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    }
}
</script>